
const validationPatterns = {
    
    A: {
      pattern: /^[a-zA-Z]*$/,
      description: "alphabetical"
    },
    N: {
      pattern: /^[0-9]*$/,
      description: "numerical"
    },
    D: {
      pattern: /^[0-9]*(.[0-9]+)?$/,
      description: "decimal"
    },
    ND: {
      pattern: /^[0-9]{1,11}(?:\.[0-9]{1,3})?$/,
      description: "number with 3 decimal places"
    },
    ND2: {
      pattern: /^[0-9]{1,10}(?:\.[0-9]{1,2})?$/,
      description: "number with 10 digits before decimal and 2  digits after decimal"
    },
    ND7: {
      pattern: /^[0-9]{1,10}(?:\.[0-9]{0,7})?$/,
      description: "number with 10 digits before decimal and 7  digits after decimal"
    },
    ND8: {
      pattern: /^[0-9]{1,10}(?:\.[0-9]{0,8})?$/,
      description: "number with 10 digits before decimal and 8  digits"
    },
    N11D3: {
      pattern: /^[0-9]{0,11}(?:\.[0-9]{0,3})?$/,
      description: "number with 11 digit before decimal and 3 digits after decimal"
    },
    N11D7: {
      pattern: /^[0-9]{0,11}(?:\.[0-9]{0,7})?$/,
      description: "number with 11 digit before decimal and 7 digits after decimal after decimal"
    },
    AN: {
      pattern: /^[a-zA-Z0-9]*$/,
      description: "Alpha Numeric"
    },
    Alpha: {
      pattern: /^[a-zA-Z0-9 -]*$/,
      description: "Alpha Numeric"
    },
    P: {
      pattern: /^[a-zA-Z0-9 .,-/(/)/=\"%&*;<>]*$/,
      description: "A - Z, a - z, 0 – 9, space, "+" full-stop, comma, hyphen, (, ), /, = , \", %, &, *, semi-colon, <  and >"
    },
    PUOM: {
      pattern: /^[a-zA-Z0-9 .,-_/(/)/=\"%&*;<>]*$/,
      description: "A - Z, a - z, 0 – 9, space, "+" full-stop, comma, hyphen, (, ), /, = ,_, \", %, &, *, semi-colon, <  and >"
    },
    zipCode: {
      pattern: /^[a-zA-Z0-9 -]+$/,
      description: "A - Z, a - z, 0 – 9, "+" -"
    },
    NeverBeZero :{
      pattern: /^\s*$/,
      description: "can never be zero"
    },
    GreaterThanZero:{
      pattern:/0*[1-9][0-9]*(\.[0-9]+)?/,
      description: "is always greater than zero" 
    },
    Q: {
      pattern: /^[a-zA-Z0-9 ]*$/,
      description: "A - Z, 0 - 9 and space"
    },
    R: {
      pattern:  /^[a-zA-Z ]*$/,
      description: "A - Z and space"
    },
    S: {
      pattern: /^[a-zA-Z0-9 .,-/(/)/'+:=?!\"%&*;<>£$@\\^_{}/[/]~|`]*$/,
      description: "This consists of upper and lower case alphas, "+"numeric digits, spaces and special characters"
    },
    T: {
      pattern: /^[a-zA-Z0-9- ]*$/,
      description: "A - Z, 0 - 9, hyphen and space"
    },
    U: {
      pattern: /^[a-zA-Z0-9 .,-/(/)/'+:=?!\"%&*;<>]*$/,
      description: "A - Z, 0 - 9, space, "+"full-stop, comma, hyphen, (, ), /, ', +, colon, =, ?, !, \", %, &, *, semi-colon, < and >"
    },
    V:{
      pattern: /^[a-zA-Z0-9 .,-/(/)/'+:=?\"%&*<>]*$/,
      description: "A - Z, 0 - 9, space, "+"full-stop, comma, hyphen, (, ), /, ', +, colon, =, ?, \", %, &, *,< and >"
    },
    eoriNumber:{
      pattern: /^[{G}{B}]{2}[0-9]+$/,
      pattern1: /^[{X}{I}]{2}[0-9]+$/,
      pattern2: /^[{G}{B}{P}{R}]{4}$/,
      description: "first 2 characters as  GB or XI and rest should be numbers.In Special cases it can be GBPR"
    },
    gbp:{
      pattern: /^[{G}{B}{P}]{3}$/,
      description: "only be GBP"
    },
    CITY:{
      pattern: /^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/,
      description: "alphabetical"
    },
    POSTAL_CODE:{
      pattern: /^[\w\-\s]+$/,
      description: "Alpha Numeric"
    },
    PROCEDURE:{
      pattern: /^[a-z0-9]+$/i,
      description: "Alpha Numeric"
    }
  }

  export default validationPatterns ;